<template>
	<div :id='district+"_info_panel"' class='info_module'>
		<div class='info_header'>
				<h2>{{ district.replace('_', ' ').replace('santapollinare', "sant'Apollinare").replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) }}</h2>
		</div>
		<div class='district_info_panel'>
			<Percentagedistrarea name='Estensione quartiere rispetto a Rovigo' :id='district+"_area_percentage"' :district='district'/>
			<Percentagepop name='Percentuale popolazione rispetto a Rovigo' :id='district+"_pop_percentage"' :district='district'/>
			<Barchart name='Famiglie per n° di componenti' :id='district+"_fam_components"' :district='district'/>
			<Barchartgrouped name='Demografia' :id='district+"_demography"' :district='district'/> 
			<Percentage name='Composizione popolazione' :id='district+"_imm_percentage"' :district='district'/>
			<Percentagearea name='Percentuale di verde' :id='district+"_green_percentage"' :district='district'/>
		</div>
		<div class='info_header copy'>
				<h2>{{ district.replace('_', ' ').replace('santapollinare', "sant'Apollinare").replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) }}</h2>
		</div>
	</div>
</template>

<script>
import Barchartgrouped from './Barchartgrouped.vue'
import Barchart from './Barchart.vue'
import Percentage from './Percentage.vue'
import Percentagearea from './Percentagearea.vue'
import Percentagedistrarea from './Percentagedistrarea.vue'
import Percentagepop from './Percentagepop.vue'

export default {
	name: 'Districtinfo',
	props : [
		'district'
	],
	components: {
		Barchartgrouped, 
		Barchart,
		Percentage,
		Percentagearea,
		Percentagedistrarea,
		Percentagepop
	},
	mounted() {
		let component = this
		this.updateScrollNextTick()
	},
	methods : {
		updateScrollNextTick () {
	        this.$nextTick((e) => {
				let el = $('#distrs_info_container')
				el.scrollLeft(el.children().length * -480)
				console.log(window.pageYOffset)
				if (window.pageYOffset < 100) {
					window.scrollBy(0, 100)
				}
	        })
		}
	}
}
</script>

<style>
.info_module {
	display: inline-block;
	direction: ltr;
}
.district_info_panel {
	width: calc(440px + 40px);
	text-align: left; 
	padding: 20px;
	background-color: #FFF;
}
.district_info_panel svg, div, p, h3 {
	background-color: #FFF;
}
</style>
